module.exports = __webpack_public_path__ + "static/media/www.familar.fi.c4f70034.jpg";